/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { isFunction } from "@adapptio/lib-shared";

export function isMouseEventInElementArea(
	event: MouseEvent | React.MouseEvent,
	element: HTMLElement
): boolean {
	if (!isFunction(element?.getBoundingClientRect)) {
		return false;
	}

	const rect = element.getBoundingClientRect();
	const x = event.clientX;
	const y = event.clientY;

	if (x === 0 && y === 0) {
		return element.contains(event.target as Node);
	}

	if (x < rect.left || x >= rect.right) {
		return false;
	}

	if (y < rect.top || y >= rect.bottom) {
		return false;
	}

	return true;
}
